import * as React from 'react';
import { Grid, Box, Avatar, Typography } from '@mui/material';
import { themes } from '../../themes/themes';

interface IProps {
  name: string;
  picture: string;
  fontWeight?: string;
}
const EmployeeNamePic: React.FC<IProps> = ({ name, picture, fontWeight }) => {
  return (
    <div>
      <Box
        style={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'nowrap',
        }}
      >
        <Box>
          <Avatar
            src={picture}
            style={{ width: '24px', height: '24px', marginRight: '0.3em' }}
          />
        </Box>

        <Typography
          style={{
            color: themes.darkBlue,
            paddingLeft: '5px',
            alignSelf: 'center',
            fontSize: '12px',
            fontWeight: fontWeight,
          }}
        >
          {name}
        </Typography>
      </Box>
    </div>
  );
};
export default EmployeeNamePic;
